<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import { RouterLink } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';
import { useMapGetter } from 'dashboard/composables/store';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisHeader from 'dashboard/components-next/LaisHeader.vue';

const account = useAccount();
const globalConfig = useMapGetter('globalConfig/get');

const privacyUrl = computed(
  () => globalConfig.value?.privacyURL || '/lais/politica-de-privacidade'
);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <section class="flex h-full flex-col overflow-hidden bg-[#fcfaf6]">
    <LaisHeader
      title="Privacidade"
      helper="Entenda como a Imudei trata dados, comunicações e preferências dentro da sua conta."
    />

    <div class="flex-1 overflow-auto px-4 py-4 sm:px-6 lg:px-10 lg:py-6">
      <div
        class="grid gap-5 xl:grid-cols-[minmax(0,1.1fr)_minmax(320px,0.9fr)]"
      >
        <div class="grid gap-5">
          <LaisCard title="Como a Imudei usa seus dados">
            <ul class="space-y-3 text-[13px] leading-6 text-lais-text-muted">
              <li>
                Seu nome, e-mail, telefone e preferências são usados para
                autenticação, comunicação operacional e personalização da conta.
              </li>
              <li>
                Alertas por e-mail e push podem ser configurados na área de
                notificações do próprio usuário.
              </li>
              <li>
                Consentimentos por cliente ficam concentrados em
                <strong class="text-lais-text">Minha Imudei</strong>, para
                separar regras da operação comercial das preferências do seu
                login.
              </li>
              <li>
                Métricas de uso e eventos importantes podem ser registrados para
                auditoria, melhoria do produto e suporte.
              </li>
            </ul>
          </LaisCard>

          <LaisCard title="Controles disponíveis agora">
            <div class="grid gap-3 md:grid-cols-2">
              <RouterLink
                :to="account.accountScopedRoute('meus_dados_index')"
                class="rounded-lais border border-lais-border bg-white px-4 py-3 transition-all hover:border-lais-primary hover:shadow-lais-soft"
              >
                <p class="text-[14px] font-semibold text-lais-text">
                  Atualizar meus dados
                </p>
                <p class="mt-1 text-[12px] leading-5 text-lais-text-muted">
                  Nome, e-mail, telefone e atalhos pessoais da conta.
                </p>
              </RouterLink>

              <RouterLink
                :to="
                  account.accountScopedRoute(
                    'notifications_index',
                    {},
                    { tab: 'preferencias' }
                  )
                "
                class="rounded-lais border border-lais-border bg-white px-4 py-3 transition-all hover:border-lais-primary hover:shadow-lais-soft"
              >
                <p class="text-[14px] font-semibold text-lais-text">
                  Preferências de notificações
                </p>
                <p class="mt-1 text-[12px] leading-5 text-lais-text-muted">
                  Ajuste alertas por e-mail e push do seu próprio usuário.
                </p>
              </RouterLink>

              <RouterLink
                :to="account.accountScopedRoute('manual_usuario_index')"
                class="rounded-lais border border-lais-border bg-white px-4 py-3 transition-all hover:border-lais-primary hover:shadow-lais-soft"
              >
                <p class="text-[14px] font-semibold text-lais-text">
                  Manual do usuário
                </p>
                <p class="mt-1 text-[12px] leading-5 text-lais-text-muted">
                  Veja onde cada tipo de dado e preferência é gerenciado.
                </p>
              </RouterLink>

              <a
                :href="privacyUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="rounded-lais border border-lais-border bg-white px-4 py-3 transition-all hover:border-lais-primary hover:shadow-lais-soft"
              >
                <p class="text-[14px] font-semibold text-lais-text">
                  Política completa
                </p>
                <p class="mt-1 text-[12px] leading-5 text-lais-text-muted">
                  Abra a política pública atual em uma nova aba.
                </p>
              </a>
            </div>
          </LaisCard>
        </div>

        <div class="grid gap-5">
          <LaisCard title="Precisa de algo além do app?">
            <div class="space-y-3 text-[13px] leading-6 text-lais-text-muted">
              <p>
                Se você precisa revisar o texto legal completo, solicitar apoio
                operacional ou entender impactos de uma mudança de acesso, use
                os canais abaixo.
              </p>
              <div class="flex flex-wrap gap-2">
                <a
                  :href="privacyUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="inline-flex items-center gap-2 rounded-lais border border-lais-border bg-white px-3 py-2 font-semibold text-lais-text transition-all hover:border-lais-primary hover:text-lais-link"
                >
                  <span class="i-lucide-external-link size-4" />
                  Abrir política pública
                </a>
                <a
                  href="/lais/suporte/pt-BR"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="inline-flex items-center gap-2 rounded-lais border border-lais-border bg-white px-3 py-2 font-semibold text-lais-text transition-all hover:border-lais-primary hover:text-lais-link"
                >
                  <span class="i-lucide-life-buoy size-4" />
                  Abrir suporte
                </a>
              </div>
            </div>
          </LaisCard>
        </div>
      </div>
    </div>
  </section>
</template>
